import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import config from '../../../config';

import {
	CallbackResponse,
	saveTokens,
} from '../../basic/callback/Callback.hooks';
import { AppContext } from '../../../App.context';

export function useCallback(): CallbackResponse {
	const [searchParams] = useSearchParams();

	const { rebuildApolloClient, kv } = useContext(AppContext);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [error, setError] = useState<Error | null>(null);
	const code = searchParams.get('code');

	useEffect(() => {
		if (!code) {
			setError(new Error('Missing code'));
			setIsLoading(false);
			return;
		}

		const redirecUrl = [
			location.protocol,
			'//',
			location.host,
			location.pathname,
		].join('');

		const params = new URLSearchParams({
			code: `${code}`,
			redirect_uri: redirecUrl,
		});

		const url = [
			config.build.host,
			'/a360/magshop/authorize',
			'?',
			params.toString(),
		].join('');

		fetch(url, {
			method: 'GET',
			headers: {
				'app-key': config.build.appKey,
				'Content-Type': 'application/json',
			},
		})
			.then((r) => r.json())
			.then((r) => {
				kv.clear();
				saveTokens(r);
				rebuildApolloClient();
				setIsLoading(false);
			})
			.catch((e) => {
				setError(e);
				setIsLoading(false);
			});
	}, [code]);
	return {
		isLoading,
		error,
	};
}
